<template>
<div>
  <div class="list" :data-item='data.endTime'>
    <!-- 开始时间 -->
    <div class="startTime">{{startTime}}</div>
    <div class="list-item draggable_item"
    :class="[{startShow:warningText1,endShow:warningText2},`a${data.id}`]"
    draggable="true"
    :data-id="data.id"
    :style="{
        background: data.scteId > 0 ? '#000' : data.colorBack,
        border: mainSource ? 'solid 3px #FFFFFF' : 'solid 0px transparent'
      }"
    @click="openEventFormBox">
    <!-- pgm start scte 和 pgm end scte 警告提示-->
      <el-tooltip class="item" effect="dark"  placement="bottom-start" popper-class='scteWarning' v-if="data.pgmStartScte||data.pgmEndScte">
        <div slot="content">{{pgmStartTipsText(data)}}<br v-if="data.pgmStartScte"/>{{pgmEndTipsText(data)}}</div>
        <span class="warning" v-if="data.pgmStartScte||data.pgmEndScte"><i class="iconfont icon-warning2"  :class="data.liveStatus!=0&&data.liveStatus!=1?'grayWarning':''"></i></span>
      </el-tooltip>
      <!-- 是否有source -->
      <el-tooltip class="item" effect="dark"  placement="bottom-start" v-if="sourceBlank" >
        <div slot="content">{{IfSourceBlank}}</div>
        <span class="warning" ><i class="iconfont icon-a-eventwarning" ></i></span>
      </el-tooltip>
      <!-- 标题 -->
      <div  class="title" :title="data.title" >{{data.title}}</div>
      <!-- 持续时间 -->
      <div
        class="TRT"
        v-if="data.multipleModelType||data.eventModelType"
      >{{data.multipleModelType?'F/O':''}} {{data.multipleModelType&&data.eventModelType?'&':''}} {{mode[data.eventModelType]}}</div>
      <div v-else class="TRT">TRT: {{ data.startTime | GETDURATION(data.endTime) }}</div>
      <!-- House ID  -->
      <div class="houseId">{{$t('lang.HouseId')}} <span v-if="data.houseId">{{data.houseId}}</span></div>
      <!-- 图标 -->
      <div
        class="IconWrap"
        @click.stop="ClickIconCompile">
        <!-- logo图标 -->
        <p
          v-if="data.logoFlag"
          :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#AE68F4' }">
          <i
            class="iconfont icon-LG"></i>
        </p>
        <!-- crawl图标 -->
        <p
          v-if="data.crawlFlag"
          :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#70BDE8' }">
          <i
            class="iconfont icon-CR"></i>
        </p>
        <!-- D图标 -->
        <p
          v-if="data.copy == 'true'"
          :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#67aa25' }">
          <i
            class="iconfont icon-duplicate1"></i>
        </p>
        <!-- cc图标 -->
        <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#aaaaaa' }">
          <i
            class="iconfont icon-cc"></i>
        </p>
        <!-- R图标 -->
        <p
          v-if="data.record"
          :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
          <i
            class="iconfont icon-secondaryrecord"></i>
        </p>
        <p
          v-else
          :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
          <i
            class="iconfont icon-secondaryrecordoff"></i>
        </p>
        <!-- s图标 -->
        <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#f2f2f2' }">
          <i
            class="iconfont icon-SCTEoff"></i>
        </p>
      </div>
    </div>
  </div>
  <!-- 子事件 -->
  <div v-for="(item,index) in data.eventSegments" :key="index">
    <div  class="eventSegments" v-if="item.segmentId==13" :style="{
        background: data.scteId > 0 ? '#000' : data.colorBack,
        border: `1px solid ${getBorderColor(data.colorBack)}`,
      }">
      <div  class="title">{{item.eventOperationType}}</div>
      <div class="IN">IN: {{segmentsTiming(item.timingIn)}}</div>
      <div class="OUT" v-if="item.eventOperationType!='SCTE'">OUT: {{segmentsTiming(item.timingOut)}}</div>
    </div>
  </div>
</div>

</template>

<script>
import Outil from '@/assets/js/utils.js'
import { EventBorderColor } from '@/assets/js/common/ParamConfig.js'
export default {
  props: {
    // 事件的信息
    data: {
      type: Object,
      default: () => { }
    },
    visibleVal: {
      default: false
    },
    // 下一个事件的信息
    nextEventMessage: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      colors: EventBorderColor,
      // 警告
      warningShow: false,
      // pgm start上边框是否显示
      warningText1: '',
      // pgm end下边框是否显示
      warningText2: '',
      mode: {
        0: '',
        1: 'HLD/MAN',
        2: 'EXT'
      },
      // SOURCE空白
      sourceBlank: 1,
      // 主源是否为空
      mainSource: false
    }
  },
  watch: {
    // 监听下一个事件
    nextEventMessage: {
      handler (val) {
        if (val.id == this.data.id) {
          if (val.pgmStartScte == 1 && val.pgmEndScte == 1) {
            this.warningShow = true
            this.warningText1 = this.$t('lang.sctePgmStartNote')
            this.warningText2 = this.$t('lang.sctePgmEndNote')
          } else if (val.pgmStartScte == 1 && val.pgmEndScte != 1) {
            this.warningShow = true
            this.warningText1 = this.$t('lang.sctePgmStartNote')
            this.warningText2 = ''
          } else if (val.pgmStartScte != 1 && val.pgmEndScte == 1) {
            this.warningText1 = '',
            this.warningText2 = this.$t('lang.sctePgmEndNote')
            this.warningShow = true
          } else {
            this.warningText1 = ''
            this.warningText2 = ''
            this.warningShow = false
          }
        } else {
          this.warningShow = false
          this.warningText1 = ''
          this.warningText2 = ''
        }
      },
      deep: true,
      immediate: true
    },
    'data.eventSegments' () {
      this.EventSourceKong()
    }
  },
  created () {
    this.EventSourceKong()
  },
  methods: {
    // pgm Start 提示文本
    pgmStartTipsText (data) {
      if (data.pgmStartScte == 1) {
        return this.$t('lang.sctePgmStartNote')
      } else {
        return ''
      }
    },
    // pgm end 提示文本
    pgmEndTipsText (data) {
      if (data.pgmEndScte == 1) {
        return this.$t('lang.sctePgmEndNote')
      } else {
        return ''
      }
    },
    // 事件边框颜色
    getBorderColor (color) {
      return this.colors[color]
    },
    // 子事件显示的开始时间和结束时间
    segmentsTiming (item) {
      return Outil.changeNewTime(item)
    },
    // 打开创建编辑框
    openEventFormBox (e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: this.data,
        type: 0
      })
    },
    // 点击图标编辑
    ClickIconCompile (e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: this.data,
        type: 1
      })
    },
    // 判断事件source是否为空，是否占满事件
    EventSourceKong () {
      let TimeBlack = false
      let sourceBlank = false
      if (!this.data.tpeerid) {
        sourceBlank = true
        this.mainSource = true
      } else {
        this.mainSource = false
      }
      let lastEvent
      this.data.eventSegments.forEach(item => {
        // 事件scte是否是开始 判断是否是scte类型
        if (item.segmentId == 2 || item.segmentId == 4 || item.segmentId == 11) {
          // 判断scte是否在开始一分钟之内
          this.IsScteStart = this.data.startTime > (item.timingIn - 60 * 1000)
        }
        if (item.segmentId == 4 || item.segmentId == 5 || item.segmentId == 10 || ((item.segmentId == 2 || item.segmentId == 11) && item.eventOperationType != 'Scte only')) {
          if (!item.sourceId) {
            sourceBlank = true
          }
        }
        if (item.segmentId != 13) {
          lastEvent = item
        }
      })
      if (lastEvent) {
        if (lastEvent.timingOut < this.data.endTime) {
          TimeBlack = true
        }
      }
      if (TimeBlack && sourceBlank) {
        this.sourceBlank = 3
      } else if (TimeBlack) {
        this.sourceBlank = 1
      } else if (sourceBlank) {
        this.sourceBlank = 2
      } else {
        this.sourceBlank = 0
      }
    }
  },
  computed: {
    startTime () {
      return Outil.changeNewTime(this.data.startTime)
    },
    // 判断source是否为空
    IfSourceBlank () {
      let Point = ''
      if (this.sourceBlank == 1) {
        Point = this.$t('lang.gapPoint')
      } else if (this.sourceBlank == 2) {
        Point = this.$t('lang.sourceBlank')
      } else if (this.sourceBlank == 3) {
        Point = this.$t('lang.gapSourceBlank')
      }
      return Point
    }
  }

}
</script>

<style lang="less" scoped>
.list{
  display: flex;
  .startTime{
    width: 95px;
     color: #999999;;
  }
  .list-item{
    height:32px;
    border-radius: 4px;
    line-height: 32px;
    display: flex;
    position: relative;
    // justify-content:flex-start;
    width: calc(100% - 95px);
    .warning{
      i{
        color: #EC5050 ;
      }
      .grayWarning{
        color: #2c3e50;
      }
      padding-left: 5px;
    }
  .title{
    color: #252525;
    width: 20%;
    text-align: left;
    padding-left: 5px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .TRT{
     color: #252525;
    width: 30%;
    text-align: center;
     white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .houseId{
      color: #252525;
    width: 30%;
    text-align: left;
     white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .IconWrap {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    padding-right: 3px;
    padding-top: 6px;
    p {
      width: 20px;
      height: 20px;
      background: #67aa25;
      text-align: center;
      line-height: 20px;
      margin-right: 2px;
      border-radius: 3px;
      i{
        color:#252525;
        font-size: 12px;
      }
      .icon-cc{
        font-size: 10px;
        transform: scale(0.7);
      }
      .icon-LG,.icon-CR,.icon-duplicate1 {
        transform: scale(0.8);
      }
    }
  }
}
.startShow{
  border-top: 2px dashed #EC5050 !important;
}
.endShow{
  border-bottom: 2px dashed #EC5050 !important;
}
}
.eventSegments{
  display: flex;
  background-color: red;
  margin-left: 110px;
  border-radius: 4px;
  .title{
   color: #252525;
    width: 30%;
    text-align: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .IN{
    color: #252525;
    width: 30%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .OUT{
    color: #252525;
    width: 30%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
